module.exports = __webpack_public_path__ + "static/media/fulcro__logo__home.fc34d985.svg";